import React from 'react';

import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Autocomplete, TextField } from '@mui/material';

import villes_france from "../res/InputVille"

function WidgetInputVille({ state, setState, id, text, code_postal, value = "", regex = null, regex_helper = "Champ non-valide", regex_key = null, type = 'text', disabled = false, readOnly = false, multiline = false, tips = "", size = "normal" }) {
  
  React.useEffect(() => {
    setState({
      id: id,
      value: value,
      error: false,
      errorMessage: null,
    });
  }, []);

  const handleKeyPress = React.useCallback((e) => {
    if (regex_key !== null && !(new RegExp(regex_key)).test(e.key))
      e.preventDefault();
  }, []);

  const handleChange = React.useCallback((e) => {
    setState((s) => ({ ...s, value: e.target.value, error: false }));
  }, []);

  const handleBlur = React.useCallback((e) => {
    if (e.target.value !== '' && regex !== null && !(new RegExp(regex)).test(e.target.value))
      setState((s) => ({ ...s, error: true, errorMessage: regex_helper }));
  }, []);

  const handleChangeAuto = (e, v) => {
    setState((s) => ({ ...s, value: v, error: false }));
  };


  return (
    <>
      {state !== null && !(code_postal in villes_france) &&
        <FormControl error={state.error} className='w-full'>
          <InputLabel htmlFor={state.id} size={size}>{text}</InputLabel>
          <OutlinedInput
            className='shadow-md shadow-gray-300'
            id={state.id}
            name={state.id}
            label={text}
            type={type}
            disabled={disabled}
            readOnly={readOnly}
            multiline={multiline}
            size={size}

            value={state.value}
            onKeyPress={handleKeyPress}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <FormHelperText>
            {state.error && state.errorMessage}
            {state.error && state.errorMessage && <br />}
            {tips}
          </FormHelperText>
        </FormControl>
      }

      {state !== null && code_postal in villes_france &&
        <FormControl error={state.error} className='w-full'>
          <Autocomplete
            className='shadow-md shadow-gray-300'
            // multiple
            // freeSolo
            id={state.id}
            options={villes_france[code_postal].sort()}
            // getOptionLabel={(option) => option}
            // readOnly={readOnly}

            value={state.value}
            onChange={handleChangeAuto}

            renderInput={(v) => (<TextField  {...v} error={state.error} variant='outlined' label={text} />)}
          />
          <FormHelperText>
            {state.error && state.errorMessage}
            {state.error && state.errorMessage && <br />}
            {tips}
          </FormHelperText>
        </FormControl>
      }
    </>
  );
}

export default React.memo(WidgetInputVille);